module.exports = __webpack_public_path__ + "static/media/va.e486a734.svg";